import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link2, Sparkles } from 'lucide-react';
import { Modal } from '@/components/Modal';
import { Button } from '@/components/Button';
import { jobHunterService, type JhApplication } from '@/services/job-hunter.service';

/** Paste any posting link (ATS or careers page) — it's read, stored and scored for the active candidate (by `agentUid`, else its first agent). */
export function ImportJobModal({ open, onClose, profileUid, agentUid, onImported }: { open: boolean; onClose: () => void; profileUid: string | null; agentUid?: string; onImported: (a: JhApplication | null) => void }) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const r = await jobHunterService.importJob(url.trim(), profileUid ?? undefined, agentUid);
      if (r.scoreError) toast.error(`Saved the job, but scoring failed: ${r.scoreError}`);
      else toast.success(r.application ? `Scored ${r.application.evaluation.fitScore} — added to matches` : 'Job saved');
      setUrl('');
      onImported(r.application);
      onClose();
    } catch { /* toasted */ } finally { setBusy(false); }
  };
  return (
    <Modal open={open} onClose={onClose} title="Add a job by link" widthClass="max-w-xl">
      <p className="text-[13px] leading-relaxed text-text-secondary">
        Paste the posting's link — Greenhouse, Lever, Ashby, Workable, SmartRecruiters, Recruitee or any careers page with a job description.
        It's read, scored against the candidate (with the selected agent's CV and countries, else the first agent's) and added to Matches — even below the bar, since you picked it.
      </p>
      <div className="mt-4 flex items-center gap-2 rounded-xl border border-border bg-surface px-3 focus-within:border-primary focus-within:ring-4 focus-within:ring-primary-soft">
        <Link2 size={16} className="text-text-muted" />
        <input autoFocus className="h-11 flex-1 bg-transparent text-sm outline-none" placeholder="https://jobs.ashbyhq.com/company/…" value={url} onChange={(e) => setUrl(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && /^https?:\/\//.test(url)) void submit(); }} />
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <Button variant="ghost" onClick={onClose}>Cancel</Button>
        <Button loading={busy} disabled={!/^https?:\/\/\S+\.\S+/.test(url.trim())} iconLeft={<Sparkles size={14} />} onClick={submit}>Read &amp; score</Button>
      </div>
    </Modal>
  );
}
